<template>
  <a-drawer
    title="文件夹详情"
    :maskClosable="false"
    width="70%"
    :visible="open"
    @close="onClose"
    destroyOnClose>
    <a-spin :spinning="!form.id">
      <!-- 基本信息 -->
      <a-descriptions :column="2" bordered size="small">
        <a-descriptions-item label="文件夹ID">{{ form.id || '-' }}</a-descriptions-item>
        <a-descriptions-item label="文件夹名称">{{ form.name || '-' }}</a-descriptions-item>
        <a-descriptions-item label="文件类型">
          <a-tag :color="getTypeColor(form.type)">
            {{ getTypeText(form.type) }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="父文件夹ID">{{ form.parentId || '0 (顶级文件夹)' }}</a-descriptions-item>
        <a-descriptions-item label="外键标识">{{ form.objId || '-' }}</a-descriptions-item>
        <a-descriptions-item label="排序号">{{ form.sort || '-' }}</a-descriptions-item>
        <a-descriptions-item label="文件夹描述" :span="2">
          <a-tooltip v-if="form.description">
            <template #title>
              <div v-html="form.description"></div>
            </template>
            <a> 查看 </a>
          </a-tooltip>
          <span v-else>-</span>
        </a-descriptions-item>
        <a-descriptions-item label="备注" :span="2">
          <a-tooltip v-if="form.remark">
            <template #title>
              <div v-html="form.remark"></div>
            </template>
            <a> 查看 </a>
          </a-tooltip>
          <span v-else>-</span>
        </a-descriptions-item>
        <a-descriptions-item label="创建时间">{{ form.createTime || '-' }}</a-descriptions-item>
        <a-descriptions-item label="修改时间">{{ form.updateTime || '-' }}</a-descriptions-item>
      </a-descriptions>
    </a-spin>
  </a-drawer>
</template>

<script>
import { getObj } from '@/api/VR/folder'
export default {
  name: 'Detail',
  data() {
    return {
      open: false,
      form: {},
      info: {},
      id: '',
    }
  },
  methods: {
    // 获取文件类型文本
    getTypeText(type) {
      const typeMap = {
        0: '文件夹',
        1: '全景',
        2: '其他',
      }
      return typeMap[type] || '未知'
    },
    // 获取文件类型颜色
    getTypeColor(type) {
      const colorMap = {
        0: 'blue',
        1: 'green',
        2: 'orange',
      }
      return colorMap[type] || 'default'
    },
    handleUpdate(record) {
      // 如果传入的是对象，取 id；如果传入的是 id，直接使用
      this.id = record && record.id ? record.id : record
      if (!this.id) {
        this.$message.error('缺少必要参数')
        return
      }
      // 重置表单和状态
      this.form = {}
      // 获取详情数据
      getObj(this.id).then((res) => {
        this.form = res.data || {}
        this.open = true
      }).catch((err) => {
        this.$message.error('获取详情失败')
        this.open = false
        console.error(err)
      })
    },
    onClose() {
      this.open = false
      this.form = {}
      this.id = ''
    },
  },
}
</script>

<style scoped>
.ant-image {
  display: block;
}

.button_add {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 20px;
}
</style>
